const api = '/api/v1/u010_p_m_auction_controller.php';
import axios from 'axios';
export const m_auction_repository =  {
    get(user_id){
        return  axios.get(`${api}?USER_ID=${user_id}`);
    },
    upd(data){
        return  axios.post(api, data);
    }
};

